import classNames from "classnames";
import { Link, useLocation } from "react-router-dom";
import { useSidebarContext } from "../../contexts/SidebarContext";
import isSmallScreen from "../../helpers/is-small-screen";
import { HiClipboardList, HiLogout, HiSearch, HiOfficeBuilding, HiIdentification, HiCog, HiUsers, HiChartBar, HiBell } from "react-icons/hi";
import { HiMegaphone } from "react-icons/hi2";
import { Sidebar } from "flowbite-react";
import { useAuth } from "../../contexts/AuthContext";

const SidebarComponent = () => {
  const { user } = useAuth();
  const { isOpenOnSmallScreens: isSidebarOpenOnSmallScreens } = useSidebarContext();
  const location = useLocation();

  return (
    <div
      className={classNames('lg:!block', {
        hidden: !isSidebarOpenOnSmallScreens,
      })}
    >
      <Sidebar
        aria-label="Sidebar with multi-level dropdown example"
        collapsed={isSidebarOpenOnSmallScreens && !isSmallScreen()}
        theme={{
          root: {
            base: 'flex fixed top-0 left-0 z-20 flex-col flex-shrink-0 pt-16 h-full duration-75 border-r border-gray-200 lg:flex dark:border-gray-700 w-64',
          }
        }}
      >
        <div className="flex h-full flex-col justify-between py-2">
          <div>
            <Sidebar.Items>
              <Sidebar.ItemGroup>
                <Link to="/">
                  <Sidebar.Item
                    icon={HiSearch}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname === '/',
                    })}
                  >
                    Discovery
                  </Sidebar.Item>
                </Link>
                <Link to="/lists">
                  <Sidebar.Item
                    icon={HiClipboardList}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/lists'),
                    })}
                  >
                    Lists
                  </Sidebar.Item>
                </Link>
                <Link to="/campaigns">
                  <Sidebar.Item
                    icon={HiMegaphone}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/campaigns'),
                    })}
                  >
                    Campaigns
                  </Sidebar.Item>
                </Link>
                <Link to="/brands">
                  <Sidebar.Item
                    icon={HiUsers}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/brands'),
                    })}
                  >
                    Clients
                  </Sidebar.Item>
                </Link>
                <Link to="/agencies">
                  <Sidebar.Item
                    icon={HiOfficeBuilding}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/agencies'),
                    })}
                  >
                    Agencies
                  </Sidebar.Item>
                </Link>
                <Link to="/virtual-managers">
                  <Sidebar.Item
                    icon={HiIdentification}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/virtual-managers'),
                    })}
                  >
                    Virtual Managers
                  </Sidebar.Item>
                </Link>
                <Link to="/notifications">
                  <Sidebar.Item
                    icon={HiBell}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/notifications'),
                    })}
                  >
                    Notifications
                  </Sidebar.Item>
                </Link>
                <Link to="/performance">
                  <Sidebar.Item
                    icon={HiChartBar}
                    as="div"
                    className={classNames({
                      'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/performance'),
                    })}
                  >
                    Performance
                  </Sidebar.Item>
                </Link>
                {user.role === 'su' && (
                  <Link to="/settings">
                    <Sidebar.Item
                      icon={HiCog}
                      as="div"
                      className={classNames({
                        'bg-gray-100 dark:bg-gray-700': location.pathname.includes('/settings'),
                      })}
                    >
                      Settings
                    </Sidebar.Item>
                  </Link>
                )}
              </Sidebar.ItemGroup>
              <Sidebar.ItemGroup>
                <Link to="/logout">
                  <Sidebar.Item
                    icon={HiLogout}
                    as="div"
                  >
                    Sign out
                  </Sidebar.Item>
                </Link>
              </Sidebar.ItemGroup>
            </Sidebar.Items>
          </div>
        </div>
      </Sidebar>
    </div>
  );
}

export default SidebarComponent;